import { DateTime } from 'luxon';

export abstract class Timestamp {
  static from(date: Date | DateTime) {
    if (date instanceof Date) {
      date = DateTime.fromJSDate(date);
    }

    return date.toUTC().toISO();
  }

  static now() {
    return this.from(DateTime.now());
  }

  static toDateTime(timestamp: string) {
    return DateTime.fromISO(timestamp);
  }
}
